// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"elU3m","mweb":"Mi1cP","readnextshimmer":"xkbsB","web":"iTamo","toipreadnextshimmer":"hYw2k","upNextShimmer":"cB36u"};